import * as exercisesConstants from './exercises';
export var exercises = exercisesConstants;
export var issueCategories = [{
  key: 'video-broken',
  label: "The video doesn't work properly",
  value: "The video doesn't work properly"
}, {
  key: 'typo-video',
  label: 'There is a typo in this video',
  value: 'There is a typo in this video'
}, {
  key: 'other',
  label: 'Other',
  value: 'Other'
}];